var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"block h-30 w-30 rounded-full",class:{'border border-grey-300': !_vm.bg || _vm.isWhite},style:({background: _vm.bg, border: _vm.bg && !_vm.isWhite ? '1px solid #F6F6F6' : '', boxShadow: _vm.active ? '0 0 0 1px black' : ''})})
}
var staticRenderFns = []

export { render, staticRenderFns }